import { render } from "./navigator.vue?vue&type=template&id=6c566cfe&scoped=true"
import script from "./navigator.vue?vue&type=script&lang=js"
export * from "./navigator.vue?vue&type=script&lang=js"

import "./navigator.vue?vue&type=style&index=0&id=6c566cfe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c566cfe"]])

export default __exports__